export default __webpack_public_path__ + "static/media/hb.14532acf.svg";